'use es6';

/**
 * Sorts array by @key
 * @param {string} key prop name used to sort array
 */
export const sortBy = key => {
  return (a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
};

/**
 * Parse `optedInIds`, `originalIds` based on each subscription.id.
 * @param {object} response subscription response from UnsubscribeApi
 * @param {bool} response.portalUnsubscribed
 * @param {Array} response.subscriptions subscriptions response
 * @param {object} response.SubscriptionType subscription's Record type (Subscription or SubscriptionDefinition)
 * @return {object}
 */
export const parseSubscriptionTypes = ({
  portalUnsubscribed,
  subscriptions,
  SubscriptionType
}) => {
  const optedInIds = [];
  const originalIds = [];
  const types = [];
  subscriptions.forEach(sub => {
    originalIds.push(sub.id);
    if (!portalUnsubscribed && (sub.subscribed || sub.checkboxChecked)) {
      optedInIds.push(sub.id);
    }
    types.push(new SubscriptionType(sub));
  });
  return {
    optedInIds,
    originalIds,
    types
  };
};